import { render, staticRenderFns } from "./evaluations_info.vue?vue&type=template&id=08d024b2&scoped=true"
import script from "./evaluations_info.vue?vue&type=script&lang=js"
export * from "./evaluations_info.vue?vue&type=script&lang=js"
import style0 from "./evaluations_info.vue?vue&type=style&index=0&id=08d024b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d024b2",
  null
  
)

export default component.exports